import React, { useState } from "react";
import { useUser } from "./Context/UserContext";
import Icon from "./ui/Icon";
import "../profile.css";

/* First + last word initials — matches the navbar avatar. */
export function getInitials(name) {
    const words = (name || "U").trim().split(/\s+/).filter(Boolean);
    if (words.length === 0) return "U";
    const first = words[0][0] || "";
    const last = words.length > 1 ? words[words.length - 1][0] || "" : "";
    return (first + last).toUpperCase();
}

/* "2010-01-18T00:00:00" → "18 Jan 2010" (falls back to the raw value). */
function formatDate(value) {
    if (!value) return "N/A";
    const d = new Date(value);
    if (isNaN(d.getTime())) return value;
    return d.toLocaleDateString(undefined, {
        day: "2-digit",
        month: "short",
        year: "numeric",
    });
}

const VISIBLE_ROLES = 3;

export default function Profile() {
    const { empId, userInfo } = useUser();
    const [showAllRoles, setShowAllRoles] = useState(false);

    if (!userInfo) return <div className="profile-container">Please log in</div>;

    const roles = Array.isArray(userInfo.roles) ? userInfo.roles.filter(Boolean) : [];
    const visibleRoles = showAllRoles ? roles : roles.slice(0, VISIBLE_ROLES);
    const hiddenCount = roles.length - VISIBLE_ROLES;

    return (
        <div className="profile-container">
            {/* Brand header band */}
            <div className="profile-hero">
                <span className="profile-avatar" aria-hidden="true">
                    {getInitials(userInfo.name)}
                </span>
            </div>

            <div className="profile-identity">
                <h3 className="profile-name" title={userInfo.name}>{userInfo.name}</h3>
                <p className="profile-empid num">
                    <Icon name="user" size={13} />
                    {empId}
                </p>

                {/* Roles as wrapping chips, collapsed past the first few */}
                {roles.length > 0 ? (
                    <div className="profile-roles">
                        {visibleRoles.map(role => (
                            <span key={role} className="badge-mt badge-neutral profile-role-chip" title={role}>
                                {role}
                            </span>
                        ))}
                        {hiddenCount > 0 && (
                            <button
                                type="button"
                                className="profile-role-more"
                                onClick={e => {
                                    e.stopPropagation(); // keep the dropdown open
                                    setShowAllRoles(s => !s);
                                }}
                                aria-expanded={showAllRoles}
                            >
                                {showAllRoles ? "Show less" : `+${hiddenCount} more`}
                            </button>
                        )}
                    </div>
                ) : (
                    <p className="role">No Role Assigned</p>
                )}
            </div>

            <div className="info">
                <p>
                    <span className="info-icon"><Icon name="mail" size={15} /></span>
                    <strong>Email</strong>
                    <span className="info-value" title={userInfo.email}>{userInfo.email}</span>
                </p>
                <p>
                    <span className="info-icon"><Icon name="calendar" size={15} /></span>
                    <strong>Date of Joining</strong>
                    <span className="info-value num">{formatDate(userInfo.doj)}</span>
                </p>
                <p>
                    <span className="info-icon"><Icon name="users" size={15} /></span>
                    <strong>Reporting Manager</strong>
                    <span className="info-value" title={userInfo.reportingMgrName || undefined}>
                        {userInfo.reportingMgrName || "N/A"}
                    </span>
                </p>
                <p>
                    <span className="info-icon"><Icon name="clipboard" size={15} /></span>
                    <strong>Manager ID</strong>
                    <span className="info-value num">{userInfo.reportingMgrId || "N/A"}</span>
                </p>
            </div>
        </div>
    );
}
